<template>
    <svg class="account-icon" :data-theme-icon="name" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <template v-if="name === 'profile'">
            <circle cx="12" cy="8" r="3.5" />
            <path d="M5 20c.7-4 3-6 7-6s6.3 2 7 6" />
        </template>
        <template v-else-if="name === 'records'">
            <rect x="5" y="3" width="14" height="18" rx="2" />
            <path d="M9 8h6M9 12h6M9 16h4" />
        </template>
        <template v-else-if="name === 'transaction' || name === 'wallet'">
            <path d="M4 7.5h15a2 2 0 0 1 2 2v8.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12" />
            <path d="M16 12h5v4h-5a2 2 0 0 1 0-4Z" />
        </template>
        <template v-else-if="name === 'history'">
            <path d="M4 5v5h5" />
            <path d="M5.5 16.5A8 8 0 1 0 4 10" />
            <path d="M12 8v5l3 2" />
        </template>
        <template v-else-if="name === 'password'">
            <rect x="4" y="10" width="16" height="11" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
        </template>
        <template v-else-if="name === 'language'">
            <circle cx="12" cy="12" r="9" />
            <path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" />
        </template>
        <template v-else-if="name === 'chat'">
            <path d="M4 5h16v11H9l-5 4V5Z" />
            <path d="M8 10h.01M12 10h.01M16 10h.01" />
        </template>
        <template v-else-if="name === 'install'">
            <path d="M12 3v12M8 11l4 4 4-4" />
            <path d="M4 19h16" />
        </template>
        <template v-else-if="name === 'logout'">
            <path d="M10 4H5v16h5M14 8l4 4-4 4M18 12H9" />
        </template>
        <template v-else-if="name === 'copy'">
            <rect x="8" y="8" width="11" height="11" rx="2" />
            <path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3" />
        </template>
        <template v-else-if="name === 'deposit'">
            <path d="M4 7.5h15a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12" />
            <path d="M12 10v7M8.5 13.5h7" />
        </template>
        <template v-else-if="name === 'withdraw'">
            <path d="M4 7.5h15a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12" />
            <path d="M8.5 13.5h7" />
        </template>
        <template v-else-if="name === 'gift'">
            <rect x="3" y="9" width="18" height="12" rx="1" />
            <path d="M2 9h20V5H2v4ZM12 5v16M12 5c-3 0-5-1-5-3 3-1 5 0 5 3ZM12 5c3 0 5-1 5-3-3-1-5 0-5 3Z" />
        </template>
        <template v-else-if="name === 'crown'">
            <path d="m3 6 4 4 5-7 5 7 4-4-3 12H6L3 6ZM7 22h10" />
        </template>
        <template v-else-if="name === 'calendar' || name === 'calendar-check'">
            <rect x="3" y="5" width="18" height="16" rx="2" />
            <path d="M7 2v6M17 2v6M3 10h18" />
            <path v-if="name === 'calendar-check'" d="m8 15 3 3 5-5" />
        </template>
        <template v-else-if="name === 'shield-check'">
            <path d="m12 2 8 4v6c0 5-8 10-8 10S4 17 4 12V6l8-4Z" />
            <path d="m8 12 3 3 5-5" />
        </template>
        <template v-else-if="name === 'repeat'">
            <path d="M20 3v6h-6M4 21v-6h6M4 9a8 8 0 0 1 13-4l3 4M4 15l3 4a8 8 0 0 0 13-4" />
        </template>
        <template v-else-if="name === 'lock'">
            <rect x="6" y="10" width="12" height="11" rx="2" />
            <path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
        </template>
        <template v-else-if="name === 'circle-check'">
            <circle cx="12" cy="12" r="9" />
            <path d="m7 12 3.5 3.5L17 9" />
        </template>
        <template v-else-if="name === 'notification'">
            <path d="M6 9a6 6 0 0 1 12 0c0 7 3 7 3 9H3c0-2 3-2 3-9ZM10 21h4M12 2V1" />
        </template>
        <template v-else-if="name === 'chevron'">
            <path d="m9 5 7 7-7 7" />
        </template>
        <template v-else-if="name === 'up' || name === 'down'">
            <circle cx="12" cy="12" r="9" />
            <path v-if="name === 'up'" d="M12 17V7m-4 4 4-4 4 4" />
            <path v-else d="M12 7v10m-4-4 4 4 4-4" />
        </template>
        <template v-else-if="name === 'menu'">
            <path d="M3 5h18M3 12h18M3 19h18" />
        </template>
        <template v-else-if="name === 'refresh'">
            <path d="M20 4v6h-6M4 20v-6h6M4 10a8 8 0 0 1 13-5l3 5M4 14l3 5a8 8 0 0 0 13-5" />
        </template>
        <template v-else-if="name === 'arrow'">
            <path d="M4 12h16m-7-7 7 7-7 7" />
        </template>
        <template v-else-if="name === 'back'">
            <path d="M19 12H5M11 6l-6 6 6 6" />
        </template>
        <template v-else>
            <path d="M5 12h14M12 5v14" />
        </template>
    </svg>
</template>

<script>
export default {
    name: 'AccountIcon',
    props: {
        name: { type: String, default: '' }
    }
}
</script>

<style scoped>
.account-icon {
    width: 1em;
    height: 1em;
    stroke: currentColor;
    stroke-width: 1.7;
    stroke-linecap: round;
    stroke-linejoin: round;
}
</style>
